import { ArrayParam, useQueryParam, withDefault } from 'use-query-params';
import { isEqual } from 'lodash';

// This is also set on BE
export const MIN_SHIFT_DURATION = 4;
export const MIN_SHIFT_LENGTH = 0;
export const MAX_SHIFT_LENGTH = 16;
export const DEFAULT = [MIN_SHIFT_LENGTH, MAX_SHIFT_LENGTH];
// meant for withDefault
const STRING_DEFAULT = DEFAULT.map((boundary) => `${boundary}`);

export const OPTIONS = [
  {
    label: '0h',
    value: 0,
  },
  {
    label: '4h',
    value: 4,
  },
  {
    label: '8h',
    value: 8,
  },
  {
    label: '12h',
    value: 12,
  },
  {
    label: '16h',
    value: 16,
  },
];

interface IUseShiftLength {
  shiftLength: number[];
  min: number;
  max: number;
  clearShiftLength: () => void;
  setShiftLength: (shiftLength: number[]) => void;
  hasShiftLength: boolean;
}

export const useShiftLength = (): IUseShiftLength => {
  const [shift_length, setQuery] = useQueryParam(
    'shift_length',
    withDefault(ArrayParam, STRING_DEFAULT),
  );

  const shiftLength = shift_length.map((boundary) => Number(boundary));
  const [min, max] = shiftLength;
  const hasShiftLength = !isEqual(shiftLength, DEFAULT);

  const clearShiftLength = () => setQuery(undefined, 'replaceIn');

  const setShiftLength = (shiftLength) =>
    isEqual(shiftLength, DEFAULT) ? clearShiftLength() : setQuery(shiftLength, 'replaceIn');

  return {
    shiftLength,
    min,
    max,
    clearShiftLength,
    setShiftLength,
    hasShiftLength,
  };
};

export default useShiftLength;
